module.exports = __webpack_public_path__ + "881a66eecfc55e47d6c2083b18685078.png";